export default "__VITE_ASSET__8bc06eeb__"